module.exports = __webpack_public_path__ + "img/icon6.57169658.svg";